export default "__VITE_ASSET__D2FoCG9t__"